<template>
  <div>
    <div class="head">
      <el-button type="primary" @click="addChannel" size="small">
        添加销售渠道
      </el-button>
    </div>
    <el-dialog
      title="添加渠道"
      :destroy-on-close="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item label="渠道用户" prop="user_id">
          <el-input-number
            v-model="form.user_id"
            size="small"
            placeholder="输入渠道用户"
          />
        </el-form-item>
        <el-form-item label="渠道名" prop="name">
          <el-input v-model="form.name" size="small" />
        </el-form-item>
        <el-form-item label="城市" prop="city">
          <el-input v-model="form.city" size="small" />
        </el-form-item>
        <el-form-item label="公司" prop="company">
          <el-input v-model="form.company" size="small" />
        </el-form-item>
        <el-form-item label="商务" prop="director">
          <el-input v-model="form.director" size="small" />
        </el-form-item>
        <el-form-item label="规模" prop="scale">
          <el-input v-model="form.scale" />
        </el-form-item>
        <el-form-item label="关键字" prop="keyword">
          <el-input v-model="form.keyword" size="small" maxlength="6" minlegth="6" />
        </el-form-item>
        <el-form-item label="背景图" prop="title_map">
          <el-input v-model="form.title_map" size="small" />
        </el-form-item>
        <el-form-item label="显示详情" prop="show_explain">
          <el-switch v-model="form.show_explain" size="small" />
        </el-form-item>
        <el-form-item label="二维码" prop="qr_code">
          <el-input v-model="form.qr_code" size="small" />
        </el-form-item>
        <el-form-item label="传播方式" prop="spread_mode">
          <el-select
            v-model="form.spread_mode"
            placeholder="请选择传播方式"
          >
            <el-option
              v-for="(item, index) in selectList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改二维码"
      :destroy-on-close="true"
      :visible.sync="dialogUpdateVisible"
    >
      <el-form :model="updateForm" ref="updateForm" :rules="updateFormRules">
        <el-form-item label="二维码" prop="qr_code">
          <el-input v-model="updateForm.qr_code" size="small" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUpdateVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      custom-class="qr-dialog"
      title="渠道二维码"
      :destroy-on-close="true"
      :visible.sync="showQrcode"
      center
    >
      <el-form :model="qrCode" ref="qrCode" :rules="qrCodeRules" inline>
        <el-form-item label="cid" prop="cid">
          <el-input-number
            v-model="qrCode.cid"
            size="small"
            placeholder="请输入cid"
          />
        </el-form-item>
        <el-button @click="handleShowQrcode">生成二维码</el-button>
      </el-form>
      <div id="qrcode" ref="qrCodeDiv" class="qrcode"></div>
      <div>{{qrCode.url}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showQrcode = false">取 消</el-button>
        <el-button type="primary" @click="downloadQrcode">下载</el-button>
      </div>
    </el-dialog>
    <el-table :data="dataList" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="name" label="渠道名" />
      <el-table-column prop="city" label="城市" />
      <el-table-column prop="company" label="公司" />
      <el-table-column prop="scale" label="团队规模" />
      <el-table-column prop="director" label="商务" />
      <el-table-column prop="code" label="代码" />
      <el-table-column prop="keyword" label="关键字" />
      <el-table-column label="链接">
        <template slot-scope="s">
          {{ `https://fm.tling.vip/${s.row.spread_mode}/${s.row.code}` }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status === 100"
            @change="handleChangeStatus(scope.row)" 
          />
        </template>
      </el-table-column>
      <el-table-column prop="id" label="操作">
        <template slot-scope="scope">
          <el-button size="small" @click="handleClickItem(scope.row)"
          >专属产品</el-button
          >
          <el-button size="small" @click="handleClickSaleList(scope.row)"
          >销售记录</el-button
          >
          <el-button size="small" @click="handleClickSaleStatistics(scope.row)"
            >销售汇总</el-button
          >
          <el-button size="small" @click="handleShowQrcodeDialog(scope.row)"
          >渠道二维码</el-button
          >
          <el-button size="small" @click="updateChannel(scope.row)"
          >修改二维码</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pager
      ref="pager"
      api="channel_list"
      model="shop"
      @data-changed="onDataChanged"
    />
  </div>
</template>
<script>
import Pager from "../ui/Pager";
import request from "../../api/request";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
export default {
  name: "ShopChannelList",
  components: { Pager },
  data() {
    return {
      selectList: [],
      row_id:0,
      form: {
        user_id: 0, 
        name: "",
        city: "",
        company: "",
        scale: "",
        director: "",
        title_map: "",
        qr_code: "",
        spread_mode:"",
        keyword:"",
        show_explain: true
      },
      updateForm: {
        qr_code: "",
      },
      qrCode:{
        id:'',
        code:'',
        cid:0,
        spread_mode:'',
        url:''
      },
      formRules: {
        user_id: [
          {
            required: true,
            message: "会员不能为空"
          },
          {
            type: "number",
            message: "会员ID必须为数值"
          }, 
          {
            validator: (rule, value, callback) => {
              if (value > 0) {
                callback();
              } else {
                callback(new Error("会员ID必须大于0"));
              }
            },
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        city: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        company: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        director: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        title_map: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        qr_code: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        show_explain: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        scale: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        spread_mode: [
          {
            required: true,
            message: "不能为空"
          }
        ],
        keyword: [
          {
            min: 6,
            max: 6,
            message: "必须为6个字符"
          },
          {
            validator: (rule, value, callback) => {
              if (!value || RegExp('^[a-zA-Z]+$').test(value)) {
                callback();
              } else {
                callback(new Error("必须是字母"));
              }
            },
            trigger: "blur"
          },
        ]
      },
      updateFormRules: {
        qr_code: [
          {
            required: true,
            message: "不能为空"
          }
        ],
      },
      qrCodeRules: {
        cid: [
          {
            required: true,
            message: "cid不能为空"
          },
          {
            type: "number",
            message: "cid必须为数值"
          },
          {
            validator: (rule, value, callback) => {
              if (value > 0) {
                callback();
              } else {
                callback(new Error("cid必须大于0"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      dialogFormVisible: false,
      dialogUpdateVisible: false,
      loading: false,
      dataList: [],
      showQrcode: false
    };
  },
  created() {
    this.getSelectList();
  },
  methods: {
    async getSelectList() {
      const resp = await request.tools.post("defined_get",{prefix: 'SCSM_'});
      this.selectList = resp.data
    },
    addChannel() {
      this.row_id = 0;
      this.dialogFormVisible = true;
    },
    updateChannel(row) {
      this.row_id = row.id;
      this.updateForm.qr_code = row.qr_code;
      this.dialogUpdateVisible = true;
    },
    handleSubmitForm() {
      if (this.row_id === 0) {
        this.$refs["form"].validate(async valid => {
          if (valid) {
            if (!this.form.keyword) {
              delete this.form.keyword
            }
            await request.shop.post("channel_create", this.form);
            this.$message({
              message: "创建成功",
              type: "success"
            });
            this.dialogFormVisible = false;
            this.$refs["form"].resetFields();
            this.$refs["pager"].loadData();
          } else {
            this.$message({
              message: "信息填写错误",
              type: "error"
            });
          }
        });
      } else {
        this.$refs["updateForm"].validate(async valid => {
          if (valid) {
            await request.shop.post("channel_update", {
              channel: this.row_id,
              qr_code: this.updateForm.qr_code
            });
            this.$message({
              message: "更新成功",
              type: "success"
            });
            this.dialogUpdateVisible = false;
            this.$refs["updateForm"].resetFields();
            this.$refs["pager"].loadData();
          } else {
            this.$message({
              message: "信息填写错误",
              type: "error"
            });
          }
        });
      }
    },
    async handleChangeStatus(row) {
      const status = row.status === 100 ? 999 : 100;
      await request.shop.post("channel_status_update", {
        channel: row.id,
        status: status
      });
      this.dataList = this.dataList.map(r => {
        if (r.id === row.id) {
          r.status = status;
        }
        return r;
      });
    },
    // 展示渠道二维码
    handleShowQrcode() {
      this.$refs["qrCode"].validate(async valid => {
        if (valid) {
          document.getElementById("qrcode").innerHTML = "";
          this.qrCode.url = `https://fm.tling.vip/${this.qrCode.spread_mode}/${this.qrCode.code}?cid=s-${this.qrCode.id}-${this.qrCode.cid}`
          this.$nextTick(() => {
            new QRCode("qrcode", {
              width: 200,
              height: 200,
              text: this.qrCode.url, // 二维码地址
              colorDark: "#000",
              colorLight: "#fff"
            });
          });
        } else {
          this.$message({
            message: "信息填写错误",
            type: "error"
          });
        }
      });
    },
    handleShowQrcodeDialog(row) {
      this.showQrcode = true;
      this.qrCode.cid = 0
      this.qrCode.url = ''
      this.qrCode.spread_mode = row.spread_mode
      this.qrCode.code = row.code
      this.qrCode.id = row.id
    },
    downloadQrcode() {
      html2canvas(this.$refs.qrCodeDiv, {
        useCORS: true,
        scale: 3,
        removeContainer: true
      }).then(canvas => {
        let link = document.createElement("a");
        link.href = canvas.toDataURL();
        link.setAttribute("download", "qrcode.png");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
      });
    },
    handleClickItem(row) {
      this.$router.push(`/shop/ShopChannelItemList/${row.id}`);
    },
    handleClickSaleList(row) {
      this.$router.push(`/shop/ShopChannelSaleList/${row.id}`);
    },
    handleClickSaleStatistics(row) {
      this.$router.push(`/shop/ShopChannelStatistics/${row.id}`);
    },
    onDataChanged(data) {
      this.dataList = data;
    }
  }
};
</script>
<style scoped>
.qrcode {   
  width: 200px;
  text-align: center;
  margin: 20px auto;
}
>>> .qr-dialog .el-dialog__body {  
  text-align: center;
}
</style>
